import {Entity} from 'app/core/main.entity';

export class User extends Entity {
  id: number;
  title?: string;
  username?: string;
  photo? = null;

  getTitle?() {
    return this.title ? this.title : (this.username ? this.username : null);
  }

  getPhoto?(): string {
    return null;
  }
}
